<arm-layout [menuTitle]="'Routing Groups (' + (numberOfGroups || 0) + ')'" class="routing-groups">
    <div menu-header class="routing-groups-header">
        <arm-action-bar (addClick)="addGroup()" [disableAdd]="isUnauthorized" [addTooltip]="'Add Group'"
                        (editClick)="editGroup()" [disableEdit]="isUnauthorized || isNoGroupSelection()" [editTooltip]="'Edit Group'"
                        (deleteClick)="deleteGroup()" [disableDelete]="isUnauthorized || isNoGroupSelection()" [deleteTooltip]="'Delete Group'">
        </arm-action-bar>
    </div>
    <div header>
        <div class="search-container">
            <arm-search (onSearch)="onSearch($event)"
                        [searchComponent]="routingGroupsSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms">
            </arm-search>
        </div>

        <div class="action-buttons">

            <arm-action-bar (addClick)="addRule()" [disableAdd]="isUnauthorized || isNoGroupSelection()" [addTooltip]="'Add Rule'"
                            (editClick)="editRule()" [disableEdit]="isUnauthorized || isNoRuleSelection()" [editTooltip]="'Edit Rule'"
                            (deleteClick)="deleteRule()" [disableDelete]="isUnauthorized || isNoRuleSelection()" [deleteTooltip]="'Delete Rule'"
                            (refreshClick)="refresh()"></arm-action-bar>

            <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="duplicateRule()" [disabled]="isUnauthorized || isNoRuleSelection()" mat-menu-item>
                    <span>Duplicate Rule</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div menu>
        <routing-groups-panel [groups]="groups" [selectedGroup]="selectedGroup"
                              (selectChanged)="onGroupSelected($event)"
                              (deleteRequested)="deleteGroup($event)"
                              (editRequested)="editGroup($event)"
                              (moveRequested)="moveGroup($event)">
        </routing-groups-panel>
    </div>
    <div main>
        <routing-rules-panel [rules]="rules" [selectedRule]="selectedRule"
                             [selectedGroup]="selectedGroup"
                             [externalData]="externalData"
                             (selectChanged)="onRuleSelected($event)"
                             (deleteRequested)="deleteRule($event)"
                             (editRequested)="editRule($event)"
                             (moveRequested)="moveRule($event)"
                             class="drop-shadow-gray-border main-view-panel height-adjustment">
        </routing-rules-panel>
    </div>
</arm-layout>
